module.exports = __webpack_public_path__ + "static/media/23_A.ee543d40.png";